import React, { useState, useEffect } from "react";
import "./BookingForm.css";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
import { FaPlusSquare } from "react-icons/fa";
import { FaMinusSquare } from "react-icons/fa";
import { v4 as uuidv4 } from "uuid";
import { EditBookingDataById, GetOneBookingDataById } from "proxyUrl";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Select from "react-select";
import { useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Axios from "axios";
import axios from "axios";

const airlineOption = [
  {
    value: " none",
    label: " none",
  },
  {
    value: " Airline Website ",
    label: " Airline Website",
  },
  {
    value: " GTT",
    label: " GTT",
  },
  {
    value: " Trippro ",
    label: " Trippro",
  },
  {
    value: "Affection Vendor ",
    label: " Affection Vendor",
  },
];
const currencyOption = [
  {
    value: "us dollar",
    label: " US Dollar",
  },
  {
    value: " canadian  dollar ",
    label: " Canadian  Dollar",
  },
];

const BookingFormEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [dataFromApi, setDataFromApi] = useState();
  const [passangerDataFromApi, setPassangerDataFromApi] = useState([]);
  const [user_id, setUser_id] = useState();
  const [Country, setCountry] = useState();
  const [state, setState] = useState();
  const [email, setEmail] = useState("");
  const [validEmail, setValidEmail] = useState(true);
  const [Description, setDescription] = useState();
  const [submiteed, setSubmiteed] = useState(false);
  const [airlineIsuued, setAirLineIssued] = useState();
  const [currencyType, setCurrevcyType] = useState("");
  const GetBookingData = async (id) => {
    const url = `${GetOneBookingDataById}/${id}`;
    Axios.get(url, {
      withCredentials: true,
    })
      .then((res) => {
        return res;
      })
      .then((data) => {
        const allData = data.data.booking;
        const allPessangersData = JSON.parse(data.data.booking.passengers);

        setDataFromApi(allData);
        setPassangerDataFromApi(allPessangersData);
      });
  };

  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    email: "",
    pnr: "",
    totalPrice: "",
    IssuencePrice: "",
    mcuPrice: "",
    price: "",
    CardNumber: "",
    telephone: "",
    cardHolderName: "",
    date: "",
    street_address: "",
    city_address: "",
    postel_code: "",
    cell_phone_no: "",
    amount: "",
    amountDescription: "",
  });

  useEffect(() => {
    setCountry(dataFromApi ? dataFromApi.Country : "");
    setState(dataFromApi ? dataFromApi.state : "");
    setInputFields(passangerDataFromApi ? passangerDataFromApi : "");

    setAirLineIssued({
      ...airlineIsuued,
      value: dataFromApi ? dataFromApi.airlineIsuued : "",
      label: dataFromApi ? dataFromApi.airlineIsuued : "",
    });

    setCurrevcyType({
      ...airlineIsuued,
      value: dataFromApi ? dataFromApi.currencyType : "",
      label: dataFromApi ? dataFromApi.currencyType : "",
    });
    setUser({
      ...user,
      firstName: dataFromApi ? dataFromApi.firstName : "",
      lastName: dataFromApi ? dataFromApi.lastName : "",
      pnr: dataFromApi ? dataFromApi.pnr : "",
      totalPrice: dataFromApi ? dataFromApi.totalPrice : "",
      mcuPrice: dataFromApi ? dataFromApi.mcuPrice : "",
      IssuencePrice: dataFromApi ? dataFromApi.IssuencePrice : "",
      CardNumber: dataFromApi ? dataFromApi.CardNumber : "",
      cardHolderName: dataFromApi ? dataFromApi.cardHolderName : "",
      cell_phone_no: dataFromApi ? dataFromApi.cell_phone_no : "",
      street_address: dataFromApi ? dataFromApi.street_address : "",
      city_address: dataFromApi ? dataFromApi.city_address : "",
      postel_code: dataFromApi ? dataFromApi.postel_code : "",
      telephone: dataFromApi ? dataFromApi.telephone : "",
      date: dataFromApi ? dataFromApi.date : "",
    });
    setEmail(dataFromApi ? dataFromApi.email : "");
    setDescription(dataFromApi ? dataFromApi.Description : "");

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataFromApi]);

  const tork = false;
  const [userPlace, setUserPlace] = useState({
    username: "Enter Costomer Name",
    firstName: "Costomer first name",
    lastName: "Costomer last name",
    email: "Costomer Email",
    price: "$",
    CardNumber: "Credit Card Number",
    telephone: "Telephone",
    cardHolderName: "Enter Name as it Appears on the Card",
    date: "",
    street_address: "Street Address",
    city_address: "City Address",
    postel_code: "Zip/Postal Code",
    cell_phone_no: "Cell Phone Number",
    Country: "",
    region: "",
    Description: "Type Hare....",
    amount: "$",
  });

  const logged_user_info = useSelector((state) => state.user.user);

  if (tork === true) {
    setUserPlace(null);
  }
  const [inputFields, setInputFields] = useState([
    { id: uuidv4(), first_name: "", middle_name: "", last_name: "" },
  ]);
  const inputField = {
    cmastercard: "",
    cvisa: "",
    cdiscover: "",
    camericanexpress: "",
  };
  const handleEmail = (e) => {
    setEmail(e.target.value);
    // validate email and set validEmail state accordingly
    setValidEmail(/^\S+@\S+\.\S+$/.test(e.target.value));
  };

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setInputFields(newInputFields);
  };
  const handleAddFields = () => {
    setInputFields([
      ...inputFields,
      { id: uuidv4(), first_name: "", middle_name: "", last_name: "" },
    ]);
  };
  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
  };
  let name, value;
  const handleInput = (e) => {
    name = e.target.name;
    value = e.target.value;
    if (name === "firstName" && value.length > 20) {
      return;
    } else if (name === "lastName" && value.length > 20) {
      return;
    } else if (name === "price" && value.length > 10) {
      return;
    } else if (name === "pnr" && value.length > 30) {
      return;
    } else if (name === "CardNumber" && value.length > 4) {
      return;
    } else if (name === "telephone" && value.length > 15) {
      return;
    } else if (name === "cardHolderName" && value.length > 45) {
      return;
    } else if (name === "amount" && value.length > 10) {
      return;
    } else if (name === "amount" && value.length > 10) {
      return;
    } else if (name === "street_address" && value.length > 200) {
      return;
    } else if (name === "street_address" && value.length > 200) {
      return;
    } else if (name === "city_address" && value.length > 200) {
      return;
    } else if (name === "postel_code" && value.length > 20) {
      return;
    } else if (name === "cell_phone_no" && value.length > 15) {
      return;
    }
    setUser({ ...user, [name]: value });
  };

  const sendData = async (e) => {
    e.preventDefault();
    setSubmiteed(true);
    const {
      firstName,
      lastName,
      totalPrice,
      pnr,
      IssuencePrice,
      mcuPrice,
      CardNumber,
      telephone,
      cardHolderName,
      date,
      street_address,
      city_address,
      postel_code,
      cell_phone_no,
    } = user;

    const passengers = inputFields;

    if (!firstName || !lastName || !email) {
      console.log("All Fields are required!");
      toast.error("All Fields are required!", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      const delay = () => {
        setSubmiteed(false);
      };
      // eslint-disable-next-line
      const myTimeout = setTimeout(delay, 3000);

      return;
    } else if (!validEmail) {
      console.log("Please enter valid Email!");
      toast.error("Please enter valid Email!", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      const delay = () => {
        setSubmiteed(false);
      };
      // eslint-disable-next-line
      const myTimeout = setTimeout(delay, 3000);

      return;
    } else {
      const res = await axios.put(`${EditBookingDataById}/${id}`, {
        firstName,
        lastName,
        totalPrice,
        email,
        pnr,
        IssuencePrice,
        mcuPrice,
        CardNumber,
        telephone,
        cardHolderName,
        date,
        user_id,
        passengers,
        street_address,
        city_address,
        postel_code,
        cell_phone_no,
        Country,
        state,
        Description,
        airlineIsuued,
        currencyType,
      });

      if (res.status === 400) {
        console.log("Please fill all data");
        toast.error("Please fill all data!", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        const delay = () => {
          setSubmiteed(false);
        };
        // eslint-disable-next-line
        const myTimeout = setTimeout(delay, 3000);
      } else if (res.status === 200) {
        console.log("Form updated succsesfully");
        toast.success("Form updated succsesfully!", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        const delayfrfresh = () => {
          navigate(`/${logged_user_info.userRole.name}/bookings`);
        };
        // eslint-disable-next-line
        const delayRef = setTimeout(delayfrfresh, 3100);
      } else {
        console.log("something went wrong");
        toast.error("something went wrong!", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        const delay = () => {
          setSubmiteed(false);
        };
        // eslint-disable-next-line
        const myTimeout = setTimeout(delay, 3000);
      }
    }
  };
  useEffect(() => {
    if (logged_user_info) {
      setUser_id(logged_user_info.userInfo.id);
    }
    GetBookingData(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [logged_user_info]);
  // handle email field focus...........{
  function handleFocusEmail() {
    setValidEmail(true);
  }
  // ..................}
  console.log();
  return (
    <>
      <div className="mt-7  mb-2 rounded-lg bg-white shadow-xl dark:bg-navy-800 ">
        <div className="mx-auto w-[90%]  ">
          {/* <h2>Add new User</h2> */}
          <form action="" method="POST" className="">
            {/* <div className="user-image-wrapper">
								<div className="user-image"><img src="#" alt="" /> <ImCamera /></div>
								<div className="user-image-upload"> </div>
							</div> */}
            <div className="">
              <div className="field w-[100%] ">
                <div className="input  relative">
                  <label htmlFor="firstName">First Name</label>
                  <input
                    type="text"
                    placeholder={`${userPlace.firstName}`}
                    maxLength={80}
                    name="firstName"
                    id="firstName"
                    required
                    value={user.firstName}
                    onChange={handleInput}
                  />
                </div>
                <div className="input relative ">
                  <label htmlFor="lastName">Last Name</label>
                  <input
                    type="text"
                    placeholder={`${userPlace.lastName}`}
                    maxLength={80}
                    name="lastName"
                    id="lastName"
                    value={user.lastName}
                    onChange={handleInput}
                  />
                </div>
                <div className="input  relative">
                  <label htmlFor="email">Customer Email</label>
                  <input
                    type="Email"
                    placeholder={`${userPlace.email}`}
                    onFocus={handleFocusEmail}
                    name="email"
                    id="email"
                    maxLength={60}
                    value={email}
                    onChange={handleEmail}
                  />
                  {!validEmail && (
                    <p
                      className=" emailvalid  absolute left-0 mt-[3px] ml-2 text-[14px]"
                      style={{ color: "red" }}
                    >
                      Please enter a valid email
                    </p>
                  )}
                </div>
              </div>
              <div className="field w-[100%] ">
                <div className="input relative ">
                  <label htmlFor="lastName">PNR Number</label>
                  <input
                    type="text"
                    placeholder={`Enter PNR here`}
                    maxLength={80}
                    name="pnr"
                    id="lastName"
                    value={user.pnr}
                    onChange={handleInput}
                  />
                </div>
                <div className="input relative ">
                  <label htmlFor="airlineIsuued">Airline Issued By </label>
                  <Select
                    value={airlineIsuued}
                    onChange={setAirLineIssued}
                    id="airlineIsuued"
                    className="mt-2 capitalize"
                    options={airlineOption}
                  />
                </div>
              </div>
              <div className="field w-[100%] ">
                <div className="input relative ">
                  <label htmlFor="name">Choose currency type </label>
                  <Select
                    defaultValue={currencyType}
                    value={currencyType}
                    onChange={setCurrevcyType}
                    className="mt-2 capitalize"
                    options={currencyOption}
                  />
                </div>
                <div className="input relative ">
                  <label htmlFor="totalPrice">Total Price</label>
                  <input
                    type="Number"
                    min="1"
                    max="20"
                    placeholder={`${userPlace.price}`}
                    name="totalPrice"
                    id="totalPrice"
                    maxLength={20}
                    value={user.totalPrice}
                    onChange={handleInput}
                  />
                </div>
              </div>
              <div className="field w-[100%] ">
                <div className="input relative ">
                  <label htmlFor="IssuencePrice">Issuence Price</label>
                  <input
                    type="Number"
                    min="1"
                    max="20"
                    placeholder={`${userPlace.price}`}
                    maxLength={10}
                    name="IssuencePrice"
                    id="IssuencePrice"
                    value={user.IssuencePrice}
                    onChange={handleInput}
                  />
                </div>
                <div className="input relative ">
                  <label htmlFor="mcuPrice">MCU Price</label>
                  <input
                    type="Number"
                    min="1"
                    max="20"
                    placeholder={`${userPlace.price}`}
                    name="mcuPrice"
                    id="mcuPrice"
                    maxLength={20}
                    value={user.mcuPrice}
                    onChange={handleInput}
                  />
                </div>
              </div>
              <div className="field">
                <div className="input relative">
                  <label htmlFor="CardNumber" className="">
                    Enter Credit card number (last 4 Digits only)
                  </label>
                  <input
                    type="Number"
                    min="1"
                    max="20"
                    placeholder={`last 4 Digits only`}
                    name="CardNumber"
                    id="CardNumber"
                    maxLength={20}
                    value={user.CardNumber}
                    onChange={handleInput}
                  />
                </div>
                <div className="input relative">
                  <label htmlFor="telephone">
                    Cardholder's Tel (please indicate with area code)
                  </label>
                  <input
                    type="Number"
                    min="1"
                    max="20"
                    placeholder={`${userPlace.telephone}`}
                    name="telephone"
                    id="telephone"
                    value={user.telephone}
                    onChange={handleInput}
                  />
                </div>
              </div>
              <div className="field">
                <div className="input relative">
                  <label htmlFor="cardHolderName">Card Holder Name </label>
                  <input
                    type="text"
                    placeholder={`${userPlace.cardHolderName}`}
                    name="cardHolderName"
                    id="cardHolderName"
                    maxLength={80}
                    value={user.cardHolderName}
                    onChange={handleInput}
                  />
                </div>
                <div className="input  relative ">
                  <label htmlFor="date">Expiry date </label>
                  <input
                    type="date"
                    data-date-format="MM-YYYY"
                    placeholder=""
                    name="date"
                    id="date"
                    value={user.date}
                    onChange={handleInput}
                  />
                </div>
              </div>
              <h2 className="-mb-4 mt-3 ml-2  ">
                Please Mention Passenger Details below
              </h2>
              {inputFields.map((inputField) => (
                <div key={inputField.id}>
                  <div className={`${inputField.id} field`}>
                    <div className="input">
                      <input
                        type="text"
                        placeholder="First Name"
                        name="first_name"
                        maxLength={20}
                        value={inputField.first_name}
                        onChange={(event) =>
                          handleChangeInput(inputField.id, event)
                        }
                      />
                    </div>

                    <div className="input">
                      <input
                        type="text"
                        placeholder="Middle Name"
                        name="middle_name"
                        maxLength={20}
                        value={inputField.middle_name}
                        onChange={(event) =>
                          handleChangeInput(inputField.id, event)
                        }
                      />
                    </div>

                    <div className="input">
                      <input
                        type="text"
                        placeholder="Last Name"
                        name="last_name"
                        maxLength={20}
                        value={inputField.last_name}
                        onChange={(event) =>
                          handleChangeInput(inputField.id, event)
                        }
                      />
                    </div>
                  </div>
                </div>
              ))}
              <div className="mb-2 flex items-center  gap-2 px-2 text-navy-600 dark:text-navy-900">
                <div
                  className=" cursor-pointer  text-2xl dark:bg-white "
                  disabled={inputFields.length === 1}
                  onClick={() => handleRemoveFields(inputField.id)}
                >
                  <FaMinusSquare />
                </div>
                <div
                  className=" cursor-pointer text-2xl  dark:bg-white  "
                  onClick={handleAddFields}
                >
                  <FaPlusSquare />
                </div>
              </div>
              <h2 className="spacer-t20 ml-2 -mb-4">Billing Information</h2>
              <div className="field">
                <div className="input input-spacer0 relative">
                  <label htmlFor="street_address"> </label>
                  <input
                    type="text"
                    maxLength={80}
                    placeholder={`${userPlace.street_address}`}
                    name="street_address"
                    id="street_address"
                    value={user.street_address}
                    onChange={handleInput}
                  />
                </div>

                <div className="input input-spacer0 relative">
                  <label htmlFor="city_address"></label>
                  <input
                    type="text"
                    maxLength={80}
                    placeholder={`${userPlace.city_address}`}
                    name="city_address"
                    id="city_address"
                    value={user.city_address}
                    onChange={handleInput}
                  />
                </div>
              </div>
              <div className="field">
                <div className="input relative">
                  <label htmlFor="Price(USD) "> </label>
                  <input
                    type="Number"
                    min="1"
                    max="10"
                    placeholder={`${userPlace.postel_code}`}
                    name="postel_code"
                    value={user.postel_code}
                    onChange={handleInput}
                  />
                </div>
                <div className="input relative">
                  <label htmlFor="password"></label>
                  <input
                    type="Number"
                    placeholder={`${userPlace.cell_phone_no}`}
                    name="cell_phone_no"
                    value={user.cell_phone_no}
                    onChange={handleInput}
                  />
                </div>
              </div>
              <div className=" flex justify-start px-2 py-5">
                <div className=" flex w-[100%] gap-5">
                  <CountryDropdown
                    className="relative w-[50%] rounded-md border-2 border-solid border-gray-400 font-semibold  "
                    value={Country}
                    onChange={(val) => setCountry(val)}
                  />
                  <RegionDropdown
                    country={Country}
                    className=" w-[50%] rounded-md border-2 border-solid border-gray-400 p-3 font-semibold"
                    value={state}
                    onChange={(val) => setState(val)}
                  />
                </div>
              </div>
              <div className="relative mx-2">
                <h2 className="mb-1">Description</h2>
                <CKEditor
                  // className=""
                  // name="Description"
                  value={user.Description}
                  editor={ClassicEditor}
                  placeholder={`${userPlace.Description}`}
                  data={Description}
                  onReady={(editor) => {
                    // You can store the "editor" and use when it is needed.
                    // console.log("Editor is ready to use!", editor);
                  }}
                  onChange={(handleInput, editor) => {
                    const data = editor.getData();
                    setDescription(data);
                  }}
                />
              </div>
              {submiteed ? (
                <div className="field cursor-pointer ">
                  <div className=" my-5 rounded-md bg-gray-300 py-3 px-12 text-white">
                    <button disabled>Loading....</button>
                  </div>
                </div>
              ) : (
                <>
                  <div className="field cursor-pointer " onClick={sendData}>
                    <div className=" my-5 rounded-md bg-primaryBlue py-3 px-12 text-white">
                      <button type="submit"> Submit Update</button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </form>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default BookingFormEdit;
